<template>
  <div class="pb-2">
    <vx-tooltip text="Alimentar indicador" color="primary" position="left">
      <feather-icon
        icon="PlusSquareIcon"
        svgClasses="hover:text-success stroke-current mt-1"
        @click="open"
      />
    </vx-tooltip>
    <vs-popup
      :title="title + ' ' + item.id"
      accept-text="Salvar"
      cancel-text="Cancelar"
      button-cancel="border"
      @cancel="cancel"
      @accept="save"
      @close="cancel"
      :is-valid="validateForm"
      :active.sync="activePrompt"
    >
      <div
        style="overflow-x: hidden !important"
        v-if="item.alimentacao_manual == 1"
      >
        <div
          class="modal-size"
          id="table-default"
          style="overflow-x: hidden !important"
        >
          <section>
            <div style="width: 88vw; overflow-x: hidden">
              <vs-table noDataText="" dense ref="table">
                <template slot="thead">
                  <vs-th width="10%">Tipo</vs-th>
                  <vs-th :key="index2" v-for="index2 in item.meses"
                    >{{ dateChart(index2) }}
                  </vs-th>
                </template>
                <template>
                  <vs-tr style="transition-duration: 100000000s !important">
                    <vs-td style="min-width: 6vw; max-width: 7vw">
                      <p
                        style="min-width: 6vw; max-width: 7vw"
                        class="text-warning"
                      >
                        Previsto
                      </p>
                      <vs-divider></vs-divider>
                      <p
                        style="min-width: 6vw; max-width: 7vw"
                        class="text-success"
                      >
                        Realizado
                      </p>
                    </vs-td>

                    <vs-td :key="index3" v-for="index3 in item.meses">
                      <div
                        class="vx-col w-full"
                        style="min-width: 6vw; max-width: 7vw"
                      >
                        <vs-input
                          v-model="previsto[index3 - 1]"
                          class="w-full my-2"
                          :disabled="!item.alimentacao_manual"
                          color="warning"
                          v-currency="$currencyFormatterOptions"
                        />
                      </div>
                      <div
                        class="vx-col w-full"
                        style="min-width: 6vw; max-width: 7vw"
                      >
                        <vs-input
                          v-model="realizado[index3 - 1]"
                          class="w-full my-2"
                          :class="data.realizado[index3 - 1] >= data.previsto[index3 - 1] ? 'highlight-success' : ''"
                          :disabled="!item.alimentacao_manual"
                          color="success"
                          v-currency="$currencyFormatterOptions"
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </section>
        </div>

        <LineChart :data="{ ...data, data_inicio: item.data_inicio }" :meses="item.meses" :key="key"></LineChart>
        <vs-divider></vs-divider>
        <div class="vx-row">
          <div class="vx-col w-2/3"></div>
          <div class="vx-col w-1/3">
            <div class="vx-row mr-2">
              <div class="vx-col w-1/2">
                <vs-button
                  v-if="item.alimentacao_manual"
                  @click="save"
                  class="w-full"
                  type="filled"
                  color="primary"
                  >Salvar</vs-button
                >
              </div>
              <div class="vx-col w-1/2">
                <vs-button
                  @click="cancel"
                  class="w-full"
                  type="border"
                  color="primary"
                  >Cancelar</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        style="overflow-x: hidden !important"
        v-if="item.alimentacao_manual != 1"
      >
        <div
          class="modal-size"
          id="table-default"
          style="overflow-x: hidden !important"
        >
          <section>
            <div style="width: 88vw; overflow-x: hidden">
              <vs-table noDataText="" dense ref="table">
                <template slot="thead">
                  <vs-th width="10%">Tipo</vs-th>
                  <vs-th :key="index2" v-for="index2 in data.meses.length"
                    >{{
                      //dateChart(index2)

                      months[data.meses[index2 - 1] - 1] +
                      " / " +
                      data.anos[index2 - 1]
                    }}
                  </vs-th>
                </template>
                <template>
                  <vs-tr style="transition-duration: 100000000s !important">
                    <vs-td style="min-width: 6vw; max-width: 7vw">
                      <p
                        style="min-width: 6vw; max-width: 7vw"
                        class="text-warning"
                      >
                        Previsto
                      </p>
                      <vs-divider></vs-divider>
                      <p
                        style="min-width: 6vw; max-width: 7vw"
                        class="text-success"
                      >
                        Realizado
                      </p>
                    </vs-td>

                    <vs-td :key="index3" v-for="index3 in data.meses.length">
                      <div
                        class="vx-col w-full"
                        style="min-width: 6vw; max-width: 7vw"
                      >
                        <vs-input
                          v-model="previsto[index3 - 1]"
                          class="w-full my-2"
                          :disabled="!item.alimentacao_manual"
                          color="warning"
                          v-currency="$currencyFormatterOptions"
                        />
                      </div>
                      <div
                        class="vx-col w-full"
                        style="min-width: 6vw; max-width: 7vw"
                      >
                        <vs-input
                          v-model="realizado[index3 - 1]"
                          class="w-full my-2"
                          :disabled="!item.alimentacao_manual"
                          :class="data.realizado[index3 - 1] >= data.previsto[index3 - 1] ? 'highlight-success' : ''"
                          color="success"
                          v-currency="$currencyFormatterOptions"
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </section>
        </div>

        <LineChart
          :data="{ ...data, data_inicio: item.data_inicio }" 
          :meses="data.meses.length"
          :key="key"
          :anos="data.anos"
          :mesesArr="data.meses"
        ></LineChart>
        <vs-divider></vs-divider>
        <div class="vx-row">
          <div class="vx-col w-2/3"></div>
          <div class="vx-col w-1/3">
            <div class="vx-row mr-2">
              <div class="vx-col w-1/2">
                <vs-button
                  v-if="item.alimentacao_manual"
                  @click="save"
                  class="w-full"
                  type="filled"
                  color="primary"
                  >Salvar</vs-button
                >
              </div>
              <div class="vx-col w-1/2">
                <vs-button
                  @click="cancel"
                  class="w-full"
                  type="border"
                  color="primary"
                  >Cancelar</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import LineChart from "./../../../components/charts/LineChart.vue";

export default {
  components: {
    LineChart,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    itemCopy: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mesesNome: [],
      key: 0,
      data: { previsto: [], realizado: [], meses: [] },
      previsto: [],
      realizado: [],
      activePrompt: false,
      item: {},
      dataInicio: null,
      months: [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
      ],
    };
  },
  computed: {
    validateForm() {
      return (
        this.item.nome != undefined &&
        this.item.nome !== "" &&
        this.item.nome != null
      );
    },
  },
  methods: {
    async open() {
      this.item = { ...this.itemCopy };
      this.activePrompt = true;
      await this.getData();
      this.key++;
    },
    async getData() {
      await this.$vs.loading();
      await this.getIndicadorData(false);
      await this.$vs.loading.close();
    },
    replaceDots (value) {
      if (value && value.toString().search(",") !== -1) {
        value = value.replace(/\./g, "")
        value = value.replace(/,/g, ".")
      }
      return parseFloat(value)
    },
    async saveData() {
      await this.$vs.loading();
      try {
        this.data.meses = this.item.meses;
        this.data.data_inicio = this.item.data_inicio;
        this.data.previsto = this.previsto.map(x => x = this.replaceDots(x))
        this.data.realizado = this.realizado.map(x => x = this.replaceDots(x))
        this.rows = await this.$http.post(
          `alimentar_indicador/${this.item.id}`,
          this.data
        );
        this.key++
        this.$vs.notify(this.$notify.Success);
        this.$emit("done");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        await this.$vs.loading.close();
      }
    },
    async save() {
      if (this.validateForm) {
        await this.saveData();
      }
    },
    async cancel() {
      this.activePrompt = false;
    },
    async getSetores(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.setores = await this.$http.get(`setor`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
    async getIndicadorData(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.data = await this.$http.get(`get_indicador_data/${this.item.id}`);
        this.previsto = [...this.data.previsto].map(x => this.$currency(x))
        this.realizado = [...this.data.realizado].map(x => this.$currency(x))
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
    utc(data) {
      var date = new Date(data);
      var now_utc = Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth() - 1,
        date.getUTCDate() + 1
      );
      return new Date(now_utc);
    },
    dateChart(index) {
      const months = [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
      ];

      const newDate = this.utc(this.item.data_inicio);
      if (newDate != null) {
        let date = new Date(newDate.setUTCMonth(newDate.getUTCMonth() + index));
        let res = months[date.getUTCMonth()] + " / " + date.getUTCFullYear();
        // this.mesesNome.push(res);
        return res;
      }
      return "ERR";
    },
  },
  async mounted() {
  },
};
</script>
